import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_NewsListWrapper = styled.div<{ hasPaddings?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: ${p => p.hasPaddings ? '18px' : 0};
  padding-bottom: ${p => p.hasPaddings ? '18px' : 0};
`

export const SC_NewsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  background-color: ${E_Colors.White};
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`

export const SC_NewsDate = styled.div`
  color: ${E_Colors.Gray9C9CA1};
  font-size: 11px;
`

export const SC_NewsTitle = styled.div`
  color: ${E_Colors.TextPrimary};
  font-size: 14px;
`
